import { render, staticRenderFns } from "./EurekersSchool.vue?vue&type=template&id=79f4aee4&scoped=true&"
import script from "./EurekersSchool.vue?vue&type=script&lang=js&"
export * from "./EurekersSchool.vue?vue&type=script&lang=js&"
import style0 from "./EurekersSchool.vue?vue&type=style&index=0&id=79f4aee4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f4aee4",
  null
  
)

export default component.exports